import { Input as BaseInput, Box, InputProps, Text } from "@chakra-ui/react";
import { FieldEditorProps } from "../../types";
import withField from "../../../hooks/withField";
import { withFocusOut } from "hooks/useFocusOut";
import { PreFilledAdditionInfo } from "interfaces/models/inspectionItemResult";

const Input = withField<InputProps, string>(
  withFocusOut(BaseInput),
  (e) => e.target.value
);

interface PreFilledEditorProps
  extends FieldEditorProps<PreFilledAdditionInfo> {}

const PreFilledEditor: React.FC<PreFilledEditorProps> = (props) => {
  const { groupRowIndex, inspectionResult, onChange } = props;

  const { value } = inspectionResult?.additionInfo ?? { value: "" };

  const onChangeValue = (value: string) => {
    onChange({
      additionInfo: Object.assign(inspectionResult.additionInfo || {}, {
        value,
      }),
    });
  };

  return (
    <Box mt="1rem">
      <Text fontWeight={"bold"} mb="1rem">
        記入済みテキスト
      </Text>
      <Input
        isInvalid={!value}
        path={["itemResults", groupRowIndex, "additionInfo", "value"]}
        backgroundColor="#fff"
        height="4rem"
        fontSize="1.5rem"
        borderColor="#eeeeee"
        onChange={onChangeValue}
        value={value ?? ""}
      />
    </Box>
  );
};

export default PreFilledEditor;
